<template>
    <div>
        <span>这里是个人中心</span>
    </div>
</template>

<script>
   export default {
      name: 'MyHome'
   }
</script>

<style scoped>

</style>